import "@babel/polyfill";
import "@/scripts/helpers/polyfills";

import {
  attachIE11helper,
  attachSafariBrowser,
  bindJQuery,
  handleFormActions,
  handleParsleyActions
} from "@/scripts/helpers/library";
import MobileMenu from "@/modules/_old-modules/navigations/mobile-menu/mobile-menu";
import Offcanvas from "@/modules/layout/offcanvas/offcanvas";
import Accordion from "@/modules/_old-modules/containers/accordion/old-accordion";
import {
  handleComboboxClose,
  handleTabletSearch,
  handleTrackMyAccount,
  handleUserInfoAction,
  handleSelectStateChange,
  handleSelectStateApply,
  usliSearchHeader,
  headerHoverHandler,
  headerTabulationHandler,
  handleSelectStateOptions,
  handleSelectStateClose,
  handleSelectStateDisplay,
  handleHeaderSupportItem
} from "@/modules/_old-modules/layout/page-header/page-header";
import { Metric, trackResponse } from "@/scripts/helpers/tracking";

import { generateLoaderMarkup } from "@/modules/_old-modules/components/loader";

import * as Sentry from "@sentry/browser";
import { Integrations as TracingIntegrations } from "@sentry/tracing";
import UslfSearch from "@/modules/components/uslf-search";
import { initChangeTabs } from "@/ui-kit/elements/ui-tab";
import { initUiToggle } from "@/ui-kit/elements/form-elements/ui-toggle";
import { uiBreadcrumbsWithExpandHandler } from "@/ui-kit/elements/ui-breadcrumbs/ui-breadcrumbs-with-expand";
import { initCookiePolicy } from "@/modules/cookie-policy";
import { initJsCookieLibrary } from "@/scripts/helpers/js-cookie";
import { initUiInput } from "@/ui-kit/elements/form-elements/ui-input";
import { initTooltip } from "@/ui-kit/notifications/ui-tooltip";
import { initUiBanner } from "@/ui-kit/notifications/ui-banner";
import { initUiNotification } from "@/ui-kit/notifications/ui-notification";
import { initEllipsis } from "@/scripts/helpers/ellipsis";
import initUiModal from "@/ui-kit/modals";
import { initSmartMenu } from "@/scripts/helpers/jquery.smartmenus.min";
import { initServiceIssueBlock } from "@/modules/service-issue-block";
import {
  initLanguageMenu,
  initLanguageMenuLogin
} from "@/ui-kit/ui-dropdown/collection/language";
import initUiAccordion from "@/ui-kit/ui-accordion";
import { debounce } from "lodash";
import { initUiDropdown } from "@/ui-kit/ui-dropdown/ui-dropdown-select/index.js";
import { initUiButtonFocusedOnClick } from "@/ui-kit/elements/ui-button";
import { developmentModeInitialization } from "@/scripts/helpers/serviceWorker";
import { lazyLoadingBackgroundImages } from "@/scripts/helpers/lazyBg";

const handleAccountPageRedirect = () => {
  if ($(".js-account-link").length) {
    return $(".js-account-link").on("click", function(event) {
      const href = $(this).attr("href");

      if (
        href !== window.location.href &&
        window.location.pathname !== "/my-account/"
      ) {
        event.preventDefault();
        generateLoaderMarkup("layout-responsive", "global-loader");
        window.location = href;
      }
    });
  }
  return false;
};

bindJQuery();

// remove if disclaimer--v4 lost or the metric will become unnecessary
const trackDisclaimerWhenInViewport = () => {
  $.fn.isInViewport = function() {
    const elementTop = $(this).offset().top;
    const elementBottom = elementTop + $(this).outerHeight();

    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  const disclaimerSelector = $(".disclaimer.disclaimer--v4");
  let isMetricSent = false;

  $(window).on(
    "resize scroll",
    debounce(() => {
      disclaimerSelector.each(function(index, element) {
        element = $(element);
        if (!isMetricSent && element.is(":visible") && element.isInViewport()) {
          trackResponse({ name: "usl_disclaimer_in_viewport" });
          isMetricSent = true;
        }
      });
    }, 100)
  );
};

// if page has this - 'data-send-metric-when-in-viewport' - track metric
const trackGlobalWhenElementInViewport = () => {
  $.fn.isInViewport = function() {
    const elementTop = $(this).offset().top;
    const elementBottom = elementTop + $(this).outerHeight();

    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  const metricSelector = $("[data-send-metric-when-in-viewport]");

  let isMetricSent = {};

  metricSelector.each(function() {
    const metricName = $(this).attr("data-send-metric-when-in-viewport");
    isMetricSent[metricName] = false;
  });

  if (metricSelector) {
    $(window).on(
      "resize scroll",
      debounce(() => {
        metricSelector.each(function(index, element) {
          element = $(element);
          const metricName = $(this).attr("data-send-metric-when-in-viewport");

          if (
            isMetricSent[metricName] === false &&
            element.is(":visible") &&
            element.isInViewport()
          ) {
            trackResponse({ name: metricName });
            isMetricSent[metricName] = true;
          }
        });
      }, 100)
    );
  }
};

$(document).ready(function() {
  $(".js-logout-link").on("click", () => {
    $("meta").each(function() {
      if ($(this).attr("itemprop") == "userId") {
        window.dataLayer &&
          window.dataLayer.push({
            event: "logout",
            user_id: $(this).attr("content")
          });
      }
    });
  });

  if ($(".lazy-bg").length) {
    lazyLoadingBackgroundImages();
  }
  const GlobalMetric = new Metric($("[data-send-metric]"));
  GlobalMetric.sendGlobalOnClick();
  GlobalMetric.sendOnScroll(
    $(".layout-responsive__footer"),
    "usl_all_footer_links_in_viewport"
  );
  trackGlobalWhenElementInViewport();
  trackDisclaimerWhenInViewport();
  if (process.env.NODE_ENV === "production") {
    Sentry.init({
      dsn:
        "https://f5f530e81a834a7fab29f9467808174d@o393202.ingest.sentry.io/5241899",
      release: `build #${process.env.BUILD_ID}`,
      environment: process.env.NODE_ENV,
      integrations: [new TracingIntegrations.BrowserTracing()],
      tracesSampleRate: 0.02
    });
  }

  // TODO: remove after refactoring and add init() from uslf-search for desktop & mobile search in header
  const mobileHeaderSearch = new UslfSearch("#mobile-search");
  const desktopHeaderSearch = new UslfSearch("#desktop-search");
  const headerSearchNotificationTooltipSelector = $(
    ".ui-notification--tooltip"
  );
  const isNotificationTooltipMobile =
    $(window).width() < 960 && headerSearchNotificationTooltipSelector.length;

  const isNotificationTooltipDesktop =
    $(window).width() > 964 && headerSearchNotificationTooltipSelector.length;

  isNotificationTooltipDesktop &&
    desktopHeaderSearch.lockSelect(headerSearchNotificationTooltipSelector);
  isNotificationTooltipMobile &&
    mobileHeaderSearch.lockSelect(headerSearchNotificationTooltipSelector);

  mobileHeaderSearch.init();
  desktopHeaderSearch.init();

  usliSearchHeader.init();
  Offcanvas();
  attachIE11helper();
  attachSafariBrowser();
  MobileMenu();
  Accordion();
  handleFormActions("subscribe-form", () => console.log("success"));
  handleUserInfoAction();
  handleTabletSearch();
  handleComboboxClose();
  handleParsleyActions();
  handleTrackMyAccount();
  handleAccountPageRedirect();
  initChangeTabs();
  initUiToggle();
  uiBreadcrumbsWithExpandHandler();
  initCookiePolicy();
  initJsCookieLibrary();
  initUiBanner();
  initUiInput();
  initTooltip();
  initUiNotification();
  initEllipsis(); // https://github.com/glinford/ellipsis.js
  initUiModal();
  initSmartMenu(); // https://github.com/vadikom/smartmenus
  initLanguageMenu(); // init language menu global because it used in footer
  initLanguageMenuLogin();
  initUiDropdown();
  initUiAccordion();
  initUiButtonFocusedOnClick();
  initServiceIssueBlock();
  developmentModeInitialization();

  isNotificationTooltipDesktop &&
    handleSelectStateChange(desktopHeaderSearch.lockReleaseSelect);
  isNotificationTooltipDesktop &&
    handleSelectStateApply(desktopHeaderSearch.lockReleaseSelect);

  isNotificationTooltipMobile &&
    handleSelectStateChange(mobileHeaderSearch.lockReleaseSelect);
  isNotificationTooltipMobile &&
    handleSelectStateApply(mobileHeaderSearch.lockReleaseSelect);

  headerHoverHandler();
  headerTabulationHandler();

  handleSelectStateOptions();

  isNotificationTooltipDesktop &&
    handleSelectStateClose(desktopHeaderSearch.lockReleaseSelect);
  isNotificationTooltipMobile &&
    handleSelectStateClose(mobileHeaderSearch.lockReleaseSelect);

  isNotificationTooltipDesktop && handleSelectStateDisplay();

  handleHeaderSupportItem();
});

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${vh}px`);

// We listen to the resize event
$(document).ready(function() {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
  /* ... */
  var windowHeight = $(window).innerHeight();
  $("body").css({ height: windowHeight });
  /* ... */
});

$(window).on(
  "resize",
  debounce(() => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }, 100)
);
